export default __webpack_public_path__ + "static/adidas-a830f0a9debe47b025d748304042846e.png";